import * as React from "react";
export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
  >
    <defs>
      <linearGradient
        id="icons-bitbucket_svg__a"
        x1="31.228%"
        y1="82.399%"
        y2="0%"
      >
        <stop offset="0%" stopColor="#FFF" stopOpacity={0.1} />
        <stop offset="100%" stopColor="#184AB8" />
      </linearGradient>
      <path
        id="icons-bitbucket_svg__b"
        d="M15.092 9l-1.01 5.892H9.919L5 20.729a.87.87 0 00.56.212h13.07a.641.641 0 00.625-.538L21.14 9h-6.048z"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <path
        fill="#FFF"
        d="M14.102 14.934H9.937L8.81 9.042h6.302l-1.01 5.892zM2.65 3a.64.64 0 00-.64.743l2.72 16.513a.87.87 0 00.851.727h13.05a.64.64 0 00.64-.538l2.72-16.698a.64.64 0 00-.64-.744L2.648 3z"
      />
      <use
        fill="url(#icons-bitbucket_svg__a)"
        xlinkHref="#icons-bitbucket_svg__b"
      />
    </g>
  </svg>
);
